import { render, staticRenderFns } from "./PayMethods.vue?vue&type=template&id=06849c7c&scoped=true&"
import script from "./PayMethods.vue?vue&type=script&lang=js&"
export * from "./PayMethods.vue?vue&type=script&lang=js&"
import style0 from "./PayMethods.vue?vue&type=style&index=0&id=06849c7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06849c7c",
  null
  
)

export default component.exports